module.exports = "<div class=\"site-wrapper\">\n  <main-header></main-header>\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <main class=\"col-sm-12 mr-sm-auto col-md-12 col-lg-9\" role=\"main\">\n        <main-nav></main-nav>\n        <router-outlet></router-outlet>\n      </main>\n      <aside class=\"col-sm-12 col-md-12 col-lg-3 d-sm-block sidebar\">\n        <sidebar></sidebar>\n      </aside>\n    </div>\n  </div>\n  <main-footer></main-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/main/main.html
// module id = ./src/app/main/components/main/main.html
// module chunks = main